import { render, staticRenderFns } from "./ModelCheckout.vue?vue&type=template&id=653169b7&"
import script from "./ModelCheckout.vue?vue&type=script&lang=js&"
export * from "./ModelCheckout.vue?vue&type=script&lang=js&"
import style0 from "./ModelCheckout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports